import { stackLL,  stackLLInputs } from './stackLLReducer'

export default {
    stackLL,
    stackLLInputs
}